<template>
  <span
    class="checkbox" :class="`${ active ? 'active' : '' } ${ color } ${ disable ? 'disable' : '' }`"
    @click="select" />
</template>

<script>
export default {
  name: 'Checkbox',

  props: {
    status: {
      type: Boolean,
      default: false
    },

    disable: {
      type: Boolean,
      default: false
    },

    color: { // 颜色，是个class，得自己添加，现有$font_color_4、$theme_color
      type: String,
      default: ''
    }
  },

  data () {
    return {
      active: this.status
    }
  },

  watch: {
    status (newStatus) {
      this.active = newStatus
    }
  },

  methods: {
    select () {
      if (this.disable) { return }

      this.active = !this.active
      this.$emit('select', this.active)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  box-sizing: border-box;
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 6px;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid $font_color_4;
  border-radius: 2px;

  &.theme {
    border-color: $theme_color;

    &.active { &::after { border-color: $theme_color; } }
  }

  &.active {
    position: relative;

    &::after {
      position: absolute;
      top: 1px;
      left: 5px;
      display: inline-block;
      width: 5px;
      height: 10px;
      content: '';
      border-right: 1px solid $font_color_4;
      border-bottom: 1px solid $font_color_4;
      transform: rotate(40deg);
    }
  }

  &.disable { // 注意：disable置灰优先级要高
    border-color: $font_color_4;

    &.active {
      &::after {
        border-color: $font_color_4;
      }
    }
  }
}
</style>
